import { ProtectedJsonAPI } from '.'

export const ReportRegistrations = ProtectedJsonAPI.extend(
  '/oadr/report_registrations',
  {
    show:    endpoint => endpoint.path(({id}) => id)
  }
)